<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core'
import UserIcon from '@/assets/components/loggedBox/user.webp'
import { userDrawer } from '@/components/goat/layout/drawers/User'
import { getLocalePath } from '@/router/langRouteBuilder.ts'
import LogoSite from '/src/assets/site_logo_min.png'

const { isDesktop } = tools
const auth = useAuthStore()

const isExpand = ref(false)
const { y: windowScrollY } = useWindowScroll()
const scrollObserver = ref({
  y: 0,
  yPrev: 0,
  isHiddenHeader: false
})
function initWatchScrollY() {
  return watch(
    () => windowScrollY.value,
    (scrollY) => {
      scrollObserver.value.isHiddenHeader = !(scrollY <= 250 || scrollObserver.value.yPrev > scrollY)
      scrollObserver.value.yPrev = scrollY
    }
  )
}
initWatchScrollY()

watch(
  () => `${isDesktop.value}_${isExpand.value}`,
  () => {
    if (!isDesktop.value && isExpand.value) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }
)
</script>

<template>
  <header
    class="fixed top-0 z-50 max-h-[90vh] w-full overflow-auto bg-white py-3 big:overflow-visible"
    :class="{ 'is-hidden': scrollObserver.isHiddenHeader }"
  >
    <div
      class="big:min-h-[63px] mx-auto flex flex-col big:flex-row h-full max-w-(--breakpoint-xl) justify-between big:justify-start px-0 big:px-2 lg:px-8 items-center leading-none"
    >
      <div class="w-full flex justify-between items-center leading-none">
        <router-link
          :to="getLocalePath('home-page')"
          @click="isExpand = false"
        >
          <img
            :src="LogoSite"
            class="mx-4 h-9 big:h-12 big:py-1"
            alt="store image"
          >
        </router-link>
        <div class="flex items-center gap-4 px-3">
          <layout-language-selector-language-selector-component />
          <div
            v-if="auth.isLogged"
            class="flex items-center justify-center"
          >
            <div class="grid grid-cols-[auto_auto] items-stretch">
              <div
                class="py-2 px-3 flex justify-center items-center text-white bg-gs-[#1e565f] bg-linear-to-b from-[#1e565f] to-[#2c7a8a] rounded-l-lg size-8 relative cursor-pointer overflow-hidden"
                @click="userDrawer = !userDrawer"
              >
                <div class="absolute inset-0">
                  <img
                    :src="UserIcon"
                    alt="benefit icon"
                  >
                </div>
              </div>
              <div
                class="p-2 flex justify-center items-center size-8 bg-[#041a1f] bg-linear-to-b from-[#041a1f] to-[#195059] text-white"
              >
                <goat-layout-page-button-hamburger
                  v-model="userDrawer"
                  disabled-animation
                  :class="{ 'translate-y-px': !userDrawer, 'translate-x-[1.5px]': userDrawer }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
header {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 5%);
  transition: top 0.5s ease-in-out;

  &.is-hidden {
    top: -100vh !important;
  }

  ul {
    transition: max-height 0.2s ease-out;

    li {
      letter-spacing: 0.1px;

      a {
        font-weight: 700;
      }
    }
  }
}
</style>

<style>
@layer components {
  body {
    padding-top: 60px;
    margin-top: 0;

    &.expand-menu {
      overflow: hidden;
    }

    @media (width >= 900px) {
      padding-top: 90px !important;
      margin-top: 0;
    }
  }
}
</style>
